export default __webpack_public_path__ + "static/media/list-icon.0d475423.svg";